import { BuilderComponent } from '@builder.io/react'

import type { BuilderContent } from '@builder.io/sdk'

import { BuilderAds } from '@/legacy/components/Advertising'
import { BUILDER_BLOG_MODEL } from '@/legacy/config/builder'

interface ContentProps {
  contentTop: BuilderContent
  contentBottom: BuilderContent
}

interface SplittedBlocksProps {
  blocks: ContentProps | null
  adsMiddle: BuilderContent
}

export const SplittedBlocks = ({ blocks, adsMiddle }: SplittedBlocksProps) => (
  <>
    <BuilderComponent model={BUILDER_BLOG_MODEL} content={blocks?.contentTop} />
    <BuilderAds position="middle" adsContent={adsMiddle} />
    <BuilderComponent model={BUILDER_BLOG_MODEL} content={blocks?.contentBottom} />
  </>
)
